
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Cm24SystemBar',

  computed: {
    ...mapState('settings', ['settings']),
    systemBar () {
      return this.settings?.system_bar && this.settings?.system_bar?.value === true
    },
    systemBarDescription () {
      return this.settings?.system_bar?.description
    }
  },
  async mounted () {
    try {
      await this.getCm24Setting('system_bar')
    } catch (e) {
      // console.log(e)
    }
  },
  methods: {
    ...mapActions('settings', ['getCm24Setting'])
  }
}
